export class BrowserAdapter {
    getStoredExperiments() {
        try {
            const stored = localStorage?.getItem('client-experiments');
            if (!stored)
                return {};
            const parsed = JSON.parse(stored);
            if (!parsed || typeof parsed !== 'object')
                return {};
            return parsed;
        }
        catch (error) {
            console.error('Failed to parse stored experiments', error);
            return {};
        }
    }
    getQueryParams() {
        return new URLSearchParams(window.location.search);
    }
    getRequestUri() {
        return window.location.pathname;
    }
}
